
export default {
  data () {
    return {
      // 当前页数
      currentPage: 1,
      // 总数
      total: 0,
      // 每页显示条数
      pageSize: 15,
      tableData: [],
      selectedData: []
    }
  },
  methods: {
    // 选择列表
    handleSelectionChange (val) {
      this.selectedData = val
    },
    // 改变分页
    onSizeChange (size) {
      this.pageSize = size
      this.formInline.pageSize = this.pageSize
      this.refreshTable()
    },
    onCurrentChange (page) {
      this.currentPage = page
      this.formInline.pageNumber = this.currentPage
      this.refreshTable()
    },
    // 刷新表格数据
    refreshTable () {
      this.loadTableData()
    },
    // 顶部查询按钮提交
    onSubmit () {
      this.currentPage = 1
      this.formInline.pageNumber = 1
      this.refreshTable()
    },
    reset () {
      this.formInline = this.$options.data().formInline
      this.refreshTable()
    }
  }
}
